import { HalResource } from '../hal/models/HalResource';
import { HierarchyNode } from './HierarchyNode';
import { ContentItem } from './ContentItem';
export class HierarchyParents extends HalResource {
    constructor(data) {
        super(data);
        this.related = {
            contentItem: {
                /**
                 * Retrieve the content item associated with this node
                 */
                get: () => this.fetchLinkedResource('content-item', {}, ContentItem),
            },
        };
        this.parents = this.parents.map((node) => {
            return new HierarchyNode(node);
        });
    }
    setClient(client) {
        this.client = client;
        this.parents.forEach((parent) => {
            parent.setClient(client);
        });
    }
    toJson() {
        return this.toJSON();
    }
    toJSON() {
        return Object.assign(super.toJSON(), {
            parents: this.parents.map((parent) => parent.toJSON()),
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGllcmFyY2h5UGFyZW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWwvSGllcmFyY2h5UGFyZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sMkJBQTJCLENBQUM7QUFDeEQsT0FBTyxFQUFzQixhQUFhLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUVwRSxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBVTVDLE1BQU0sT0FBTyxnQkFBaUIsU0FBUSxXQUFXO0lBWS9DLFlBQVksSUFBUztRQUNuQixLQUFLLENBQUMsSUFBSSxDQUFDLENBQUM7UUF5QlAsWUFBTyxHQUFHO1lBQ2YsV0FBVyxFQUFFO2dCQUNYOzttQkFFRztnQkFDSCxHQUFHLEVBQUUsR0FBeUIsRUFBRSxDQUM5QixJQUFJLENBQUMsbUJBQW1CLENBQUMsY0FBYyxFQUFFLEVBQUUsRUFBRSxXQUFXLENBQUM7YUFDNUQ7U0FDRixDQUFDO1FBL0JBLElBQUksQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRTtZQUN2QyxPQUFPLElBQUksYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ2pDLENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVELFNBQVMsQ0FBQyxNQUFpQjtRQUN6QixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQztRQUVyQixJQUFJLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxDQUFDLE1BQU0sRUFBRSxFQUFFO1lBQzlCLE1BQU0sQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLENBQUM7UUFDM0IsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0lBRUQsTUFBTTtRQUNKLE9BQU8sSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDO0lBQ3ZCLENBQUM7SUFFRCxNQUFNO1FBQ0osT0FBTyxNQUFNLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxNQUFNLEVBQUUsRUFBRTtZQUNuQyxPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQyxNQUFNLEVBQUUsRUFBRSxDQUFDLE1BQU0sQ0FBQyxNQUFNLEVBQUUsQ0FBQztTQUN2RCxDQUFDLENBQUM7SUFDTCxDQUFDO0NBV0YifQ==